exports = module.exports = require("./../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "h1{font-family:Roboto,Helvetica,Arial,sans-serif;font-size:4.3vmin;font-weight:500;line-height:9vmin}h1,h2{margin:0}h2{font-family:Roboto Condensed,Arial Narrow,Helvetica,Arial,sans-serif;font-size:3.5vmin;font-weight:400}.header-secondary{width:100%;height:100%;display:block;position:relative}.header-secondary .header-secondary-title,.header-secondary .weather-icons-container,.header-secondary logo{display:inline-block;position:relative;height:100%}.header-secondary logo{width:20%}.header-secondary logo div{height:100%;position:absolute;top:22%;width:100%}.header-secondary .header-secondary-title{width:30%}.header-secondary .header-secondary-title h1{position:absolute;bottom:1vh;padding-left:.5vw;font-size:3.5vmin}.header-secondary .weather-icons-container{width:22%;float:right}.header-secondary .weather-icons-container div{top:33%;position:absolute;width:100%;float:right}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./client/app/components/common/headerSecondary/headerSecondary.scss
 ** module id = 138
 ** module chunks = 0
 **/